import React, { useEffect, useState } from "react";

import {
  Box,
  Autocomplete,
  Divider,
  ListSubheader,
  Stack,
  TextField,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { TitleText } from "@/components/atoms";
import { SelectableMenuCard } from "@/components/molecules";
import { GeoFenceLocation } from "@/types";
import { locationModeOptions } from "@/utils";


interface LocationSelectionProps {
  locations: GeoFenceLocation[];
  selection?: GeoFenceLocation[];
  onSelect: (locations: GeoFenceLocation[]) => void;
  disabled?: boolean;
}

const LocationSelection: React.FC<LocationSelectionProps> = ({
  locations,
  selection,
  onSelect,
  disabled = false,
}) => {
  const theme = useTheme();

  const [mode, setMode] = useState<string>("national");

  useEffect(() => {
    if (selection && selection.length > 0) setMode('selected');
  }, [selection])

  const handleLocationSelect = (event: any, locations: GeoFenceLocation[]) => {
    onSelect(locations);
  };

  useEffect(() => {
    if(mode === 'national' && selection && selection.length > 0) onSelect([]);
  }, [mode, onSelect, selection])

  return (
    <Stack
      spacing={2}
      // border={1}
      // borderRadius={1}
      // borderColor={theme.palette.divider}
      // p={2}
      // sx={{ minHeight: 130, minWidth: 300, maxWidth: 612 }}
    >
      <TitleText
        text="Where do they live?"
        subtext="Apply a location filter to target a specific Regions or Postal Areas."
        spacing={0.5}
      />
      <Stack direction="row" spacing={2}>
        {locationModeOptions.map((option, idx) => (
          <SelectableMenuCard
            key={idx}
            title={option.label}
            hover={option.description}
            onClick={() => setMode(option.value)}
            icon={option.icon}
            selected={mode === option.value}
            width="200px"
            disabled={disabled}
          />
        ))}
      </Stack>
      {mode === 'selected' && (
        <Box sx={{ minHeight: 56, width: 416, mt: "16px !important" }}>
          <Autocomplete
            id="location-select"
            multiple
            limitTags={2}
            disabled={disabled}
            disableCloseOnSelect
            color="secondary"
            options={locations}
            value={selection ?? []}
            onChange={handleLocationSelect}
            groupBy={(option) => option.geo_type}
            getOptionLabel={(option) => option.geo_name}
            renderGroup={(params) => [
              <Box width="100%">
                <Divider
                  textAlign="left"
                  sx={{
                    "&::before, &::after": {
                      borderColor: theme.palette.secondary.main,
                    },
                  }}
                >
                  <ListSubheader
                    key={params.key}
                    disableSticky
                    sx={{
                      textTransform: "uppercase",
                      fontFamily: "cera-pro-bold",
                      color: theme.palette.secondary.main,
                      fontSize: "16px",
                    }}
                  >
                    {params.group}
                  </ListSubheader>
                </Divider>
              </Box>,
              params.children,
            ]}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                label="Select Locations"
                variant="outlined"
                color="secondary"
                disabled={disabled}
              />
            )}
            // renderTags={() => null}
          />
        </Box>
      )}
    </Stack>
  );
};

export default LocationSelection;
